export function parseQueryString<T extends object>(str: string): Partial<T> {
  let o = {}
  str
    .replace(/^.*\?/, '')
    .split('&')
    .forEach(s => {
      const [key, val] = s.split('=') as any
      o = {
        ...o,
        [key]: /^\d+$/.test(val) ? Number(val) : decodeURIComponent(val)
      }
    })

  return o as T
}
